import { HashRouter  as Router, Routes, Route} from 'react-router-dom'
//import logo from './logo.svg';
import './App.css';
import TennisMasterApp from './Pages/TennisMasterApp'
import HomePage from './Pages/HomePage'
import PrivacyPolicy from './Pages/PrivacyPolicy';

function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route exact path="" element={<HomePage />} />
          <Route path="home" element={<HomePage />} />
          <Route path="tennismasterapp" element={<TennisMasterApp />} />
          <Route path="privacy" element={<PrivacyPolicy />} />
        </Routes>
      </Router>
    </div>
    
  );
   
}

export default App;
